import { gql } from '@apollo/client';

export const QUERY_WELLBEING_AWARENESS_DAYS_CALENDAR_PAGE = gql`
  query wellbeingAwarenessDaysCalendarPage {
    wellbeingAwarenessDaysCalendarPage {
      data {
        id
        attributes {
          title
          description
          downloadButtonText
          file {
            data {
              attributes {
                url
              }
            }
          }
          calendarFeedbackMessage {
            calendarPermissionDenied
            calendarNotFound
            eventAlreadyExists
            eventAddedSuccessGoogle
            eventAddedSuccessApple
            eventAddedSuccessGeneric
          }
          NoAwarenessDaysMonthText
        }
      }
    }
  }
`;
export const QUERY_CALENDAR_BY_YEAR = gql`
  query calendarByYear($year: Int!) {
    calendars(filters: { year: { eq: $year } }) {
      data {
        attributes {
          year
          eventDays {
            startDate
            name
            wholeMonth
            endDate
            related_resource {
              data {
                attributes {
                  slug
                }
              }
            }
            related_podcast {
              data {
                attributes {
                  slug
                }
              }
            }
          }
        }
      }
    }
  }
`;
